/**
 * Google Drive Service Factory
 * Provides the GoogleDriveService singleton
 */

import { googleDriveService } from './GoogleDriveService';
import type { GoogleDriveService } from './GoogleDriveService';

type GoogleDriveServiceInterface = GoogleDriveService;

class GoogleDriveServiceFactory {
  private static instance: GoogleDriveServiceInterface | null = null;

  /**
   * Get the Google Drive service instance
   */
  static getInstance(): GoogleDriveServiceInterface {
    if (!this.instance) {
      this.instance = googleDriveService;
    }
    return this.instance;
  }

  /**
   * Reset the factory (useful for testing)
   */
  static reset(): void {
    this.instance = null;
  }
}

// Export the factory and a convenience function
export { GoogleDriveServiceFactory };

// Convenience function to get the current service
export const getGoogleDriveService = () => GoogleDriveServiceFactory.getInstance();
